define.alias("shared/components/shared/linkinbio/modal/upgrade", "settings/components/shared/linkinbio/modal/upgrade");